import { useState } from "react"
import { setCookie } from "../helpers/cookies.js"
import "./Home.scss"
import { useTranslation } from "react-i18next"

const Watchdog = () => {
  const { t } = useTranslation()
  const [pass, setPass] = useState("")
  const [verificando, setVerificando] = useState(false)
  const ans = "bWVsbG9u"

  const handleClick = (event) => {
    event.preventDefault()
    setVerificando(true)
    setTimeout(checkPass, 2000)
  }

  const checkPass = () => {
    let b64pass = window.btoa(pass.toLowerCase()),
      ok = b64pass === ans

    setVerificando(false)

    if (!ok) return

    setCookie("unlocked", "1", 30)
    window.location.reload()
  }

  return (
    <div className="App" style={{ overflow: "hidden" }}>
      <div className="content">
        <div className="mini-container">
          <center>
            <h3>{t("watchdog.riddle")}</h3>
          </center>

          <center>
            <i>{t("watchdog.hint")}</i>
          </center>

          <form>
            <input
              type="password"
              className="my-4"
              onChange={(e) => setPass(e.target.value)}
              placeholder={t("watchdog.password")}
              style={{ borderRadius: "5px" }}
            />

            <button
              id="login-btn"
              className="btn lg azul"
              onClick={handleClick.bind(this)}
              disabled={verificando}
              type="submit">
              {!verificando && t("watchdog.submit")}
              {verificando && t("watchdog.verifying")}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Watchdog
